import React, { useState } from 'react';
import { Card, Box, Typography, CardContent } from '@material-ui/core';
import {
  useUserTrainingUpcomingCount,
  useUserTrainingUpcoming
} from '../../../user/User.hooks';
import TrainingUpcomingDialog from '../dialogs/TrainingUpcomingDialog';
import { User } from '../../../user/User.interface';
export interface TrainingUpcomingCardProps {
  user: User;
}

const TrainingUpcomingCard: React.FC<TrainingUpcomingCardProps> = ({
  user
}) => {
  const { data: upcomingTrainingsCount } = useUserTrainingUpcomingCount(
    true,
    user.id
  );
  const { data: upcomingTrainings } = useUserTrainingUpcoming(true, user.id);
  const [isOpenDialog, setIsOpenDialog] = useState(false);

  return (
    <Card>
      <CardContent>
        <Box textAlign='center' m={2}>
          <Typography
            variant='h4'
            style={{ cursor: 'pointer' }}
            onClick={() => setIsOpenDialog(true)}
          >
            {upcomingTrainingsCount}
          </Typography>
          <Typography variant='overline'>
            Upcoming Recurring Training
          </Typography>
        </Box>
      </CardContent>

      {upcomingTrainings && isOpenDialog && (
        <TrainingUpcomingDialog
          open={isOpenDialog}
          upcomingTrainings={upcomingTrainings}
          onCancel={() => setIsOpenDialog(false)}
          onCreated={() => {}}
        />
      )}
    </Card>
  );
};

export default TrainingUpcomingCard;
